import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageSquare, Send, Shield } from "lucide-react";

export default function Messages() {
  const [msgs, setMsgs] = useState([]);
  const [other, setOther] = useState(null);
  const [input, setInput] = useState("");
  const listRef = useRef(null);

  const load = async () => {
    try {
      const r = await api.get("/messages/thread");
      setMsgs(r.data.messages || []);
      setOther(r.data.other);
    } catch (e) { toast.error("Errore caricamento"); }
  };

  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  useEffect(() => { listRef.current?.scrollTo({ top: listRef.current.scrollHeight, behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!input.trim()) return;
    try {
      const r = await api.post("/messages/thread", { content: input });
      setMsgs([...msgs, r.data]);
      setInput("");
    } catch { toast.error("Errore invio"); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#E2FF31] mb-2">
        <MessageSquare className="w-3 h-3" /> Filo diretto
      </div>
      <h1 className="font-display text-5xl sm:text-6xl font-black uppercase tracking-tighter leading-[0.9] mb-8">
        Messaggi <span className="text-[#FF3B30]">al coach</span>
      </h1>

      <div className="border border-[#2A2A35] bg-[#141419]/50">
        <div className="border-b border-[#2A2A35] px-4 py-3 flex items-center gap-2 text-sm">
          <Shield className="w-4 h-4 text-[#FF3B30]" />
          <span className="font-bold uppercase tracking-widest">Il tuo coach</span>
        </div>
        <div ref={listRef} className="max-h-[550px] min-h-[350px] overflow-y-auto p-4 space-y-3" data-testid="user-thread">
          {msgs.length === 0 && (
            <div className="text-center py-8 text-[#A0A0AB] text-sm">
              Nessun messaggio ancora. Scrivi al tuo coach per feedback, dubbi, richieste.
            </div>
          )}
          {msgs.map((m) => (
            <div key={m.id} className={`flex ${!m.from_admin ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] px-3 py-2 text-sm ${
                !m.from_admin ? "bg-[#FF3B30] text-white" : "bg-[#2A2A35] text-white"
              }`}>
                <div>{m.content}</div>
                <div className="text-[9px] uppercase tracking-widest opacity-60 mt-1">
                  {m.from_admin ? "Coach" : "Tu"} · {new Date(m.created_at).toLocaleString("it-IT", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" })}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#2A2A35] p-3 flex gap-2">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send()}
            data-testid="user-msg-input"
            placeholder="Scrivi al tuo coach..."
            className="flex-1 bg-[#0B0B0F] border border-[#2A2A35] px-3 py-2 focus:border-[#FF3B30] focus:outline-none text-sm"
          />
          <button onClick={send} data-testid="user-msg-send" className="bg-[#FF3B30] text-white px-5 py-2 font-bold uppercase tracking-widest text-xs hover:bg-[#e02e24]">
            <Send className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
